import { ISpeakerPick } from '@common/interfaces/callSpeaker'
import Base from './base'

export default class CallSpeakers extends Base {
  list(meetingId: string) {
    return this.apiClient.get(`call-speakers/${encodeURIComponent(meetingId)}`)
  }

  set(meetingId: string, data: { speakerName: string } & ISpeakerPick) {
    return this.apiClient.put(`call-speakers/${encodeURIComponent(meetingId)}`, data)
  }
}
